<template lang="pug">
#bloco-visualizar-relatorio-rastreabilidade
    el-card.dados-relatorio-rastreabilidade__card
        .visualizar-relatorio-logo
            img#logo-bunge(
                src='https://lyra-bunge-publico.s3.amazonaws.com/logo-vega.png'
            )
        .visualizar-relatorio-info
            .visualizar-relatorio-info-titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.tituloRelatorio') }}
            .visualizar-relatorio-info-data
                span {{ $t('mensagens.relatorioRastreabilidade.visualizar.dataRelatorio') }}
                .visualizar-relatorio-conteudo
                    span.visualizar-relatorio-info-data--verde {{ dadosVisualizarRelatorio.dataAnalise }} -
                    span.visualizar-relatorio-info-data--hora {{ dadosVisualizarRelatorio.horaAnalise }}

        .visualizar-relatorio-dados-container
            .visualizar-relatorio-dados-gerais
                .visualizar-relatorio-dados-gerais-sub-titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.dadosGerais') }}
                .visualizar-relatorio-dados-gerais-conteudo-row
                    .visualizar-relatorio-dados-gerais-row
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.comuns.numeroContrato') }}
                            span.conteudo {{ dadosVisualizarRelatorio.dadosGerais?.numeroContrato }}
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.comuns.cultura') }}
                            span.conteudo {{ dadosVisualizarRelatorio.dadosGerais?.culturaCodigo }}
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.cadastro.volumeContratoT') }}
                            span.conteudo {{ dadosVisualizarRelatorio.dadosGerais?.volumeContrato }}
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.volumeAvaliadoRelatorio') }}
                            span.conteudo {{ dadosVisualizarRelatorio.dadosGerais?.volumeAvaliado }}

                    .visualizar-relatorio-dados-gerais-row
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.numeroImoveis') }}
                            span.conteudo {{ dadosVisualizarRelatorio.dadosGerais?.numeroImoveis }}

                    .visualizar-relatorio-dados-gerais-row
                        .bloco-conteudo-relatorio-dados-municipios
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.municipiosUfOriginados') }}
                            .bloco-conteudo-relatorio-municipios
                                span.conteudo(
                                    v-for='(municipio, index) in dadosVisualizarRelatorio.dadosGerais?.municipiosOriginados'
                                ) {{ municipio.ufNomeQuantidade }}

            .visualizar-relatorio-dados-gerais
                .visualizar-relatorio-dados-gerais-sub-titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.protocolo') }}
                .visualizar-relatorio-dados-gerais-conteudo-row
                    .visualizar-relatorio-dados-gerais-row
                        .bloco-conteudo-relatorio
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.protocoloUtilizado') }}
                            span.conteudo {{ dadosVisualizarRelatorio.protocolo?.protocoloUtilizado }}

                    .visualizar-relatorio-dados-gerais-row
                        .bloco-conteudo-relatorio-dados-indicadores-protocolo
                            span.titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.indicadoresProtocoloAnalisado') }}
                            .bloco-conteudo-relatorio-indicadores-protocolo
                                span.conteudo(
                                    v-for='(indicador, index) in dadosVisualizarRelatorio.protocolo?.indicadoresProtocolo',
                                    :key='index'
                                )
                                    span.conteudo {{ indicador }}

            .visualizar-relatorio-dados-gerais
                .visualizar-relatorio-dados-gerais-sub-titulo {{ $t('mensagens.relatorioRastreabilidade.visualizar.imoveis') }}
                .visualizar-relatorio-dados-gerais-conteudo-table
                    el-table(
                        :data='dadosVisualizarRelatorio.imoveis',
                        :highlight-selection-row='false'
                    )
                        el-table-column(prop='cpfCnpj', label='CPF/CNPJ')
                        el-table-column(
                            prop='identificadorImovel',
                            :label='$t("mensagens.relatorioRastreabilidade.visualizar.identificadorImovel")'
                        )
                        el-table-column(
                            prop='municipioUf',
                            :label='$t("mensagens.relatorioRastreabilidade.cadastro.municipioUf")'
                        )
                        el-table-column(
                            prop='safra',
                            :label='$t("mensagens.comuns.safra")'
                        )
                        el-table-column(
                            prop='volume',
                            :label='$t("mensagens.relatorioRastreabilidade.cadastro.volumeT")'
                        )
                        el-table-column(
                            prop='analise',
                            :label='$t("mensagens.relatorioRastreabilidade.visualizar.analise")'
                        )

        .visualizar-relatorio-dados-rodape
            .visualizar-relatorio-dados-rodape-conteudo
                span.visualizar-relatorio-dados-rodape-conteudo-data {{ dadosVisualizarRelatorio.geradoPorEData }}
                span.visualizar-relatorio-dados-rodape-conteudo-info {{ $t('mensagens.relatorioRastreabilidade.visualizar.mensagemDadosUsoRestrito') }}
                span.visualizar-relatorio-dados-rodape-conteudo-link(
                    @click='irParaVega'
                ) www.vegamonitoramento.com.br
</template>
<script>
export default {
    name: 'BlocoVisualizarRelatorio',

    components: {},

    props: {
        dadosVisualizarRelatorio: {
            type: Object,
            Required: true
        }
    },

    data() {
        return {};
    },

    mounted() {},

    methods: {
        irParaVega() {
            window.open('https://vegamonitoramento.com.br/', '_blank');
        }
    }
};
</script>
<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}
#bloco-visualizar-relatorio-rastreabilidade {
    el-card {
        border: 1px solid #000;
        border-radius: 0;
        padding: 20px;
        width: 300px;
        box-shadow: 2px 2px 5px #888888;
        background-color: #f0f0f0;
        text-align: center;
    }

    .titulo {
        font-size: 16px;
        color: var(--primary-lyra);
    }
    .dados-relatorio-rastreabilidade__card {
        margin-top: 10px;

        img#logo-bunge {
            width: 165.3px;
            height: 71.17px;
            margin-top: 20px;
        }

        .visualizar-relatorio-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            margin-top: 8px;

            .visualizar-relatorio-info-titulo {
                font-size: 20px;
                font-weight: bold;
                color: var(--primary-lyra);
            }

            .visualizar-relatorio-info-data {
                display: flex;
                flex-direction: column;
                gap: 5px;
            }

            .visualizar-relatorio-conteudo {
                display: flex;
                gap: 5px;
                align-items: center;

                span.visualizar-relatorio-info-data--verde {
                    font-weight: bold;
                    color: var(--primary-lyra);
                }

                span.visualizar-relatorio-info-data--hora {
                    color: #7c7c7c;
                }
            }
        }

        .visualizar-relatorio-dados-container {
            display: flex;
            flex-direction: column;
            gap: 36.73px;

            .visualizar-relatorio-dados-gerais {
                .visualizar-relatorio-dados-gerais-sub-titulo {
                    position: relative;
                    padding-bottom: 5px;
                    font-size: 20px;
                    font-weight: bold;
                    color: var(--primary-lyra);

                    &::before {
                        content: '';
                        width: 100%;
                        border-bottom: 2.3px solid var(--primary-lyra);
                        color: var(--primary-lyra);
                        position: absolute;
                        left: 0;
                        bottom: 0;
                    }
                }

                .visualizar-relatorio-dados-gerais-conteudo-row {
                    display: flex;
                    gap: 16px;
                    flex-direction: column;

                    .visualizar-relatorio-dados-gerais-row {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        gap: 143.73px;
                        align-items: center;

                        .bloco-conteudo-relatorio {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                        }

                        .bloco-conteudo-relatorio-dados-municipios,
                        .bloco-conteudo-relatorio-dados-indicadores-protocolo {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            width: 100%;

                            .bloco-conteudo-relatorio-indicadores-protocolo {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                flex-wrap: wrap;
                                gap: 8px;

                                .conteudo {
                                    width: 32%;
                                    margin-bottom: 21px;
                                }
                            }

                            .bloco-conteudo-relatorio-municipios {
                                display: flex;
                                flex-wrap: wrap;
                                width: 100%;
                                gap: 8px;

                                .conteudo {
                                    width: 24%;
                                    margin-bottom: 21px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .visualizar-relatorio-dados-gerais-conteudo-table {
            margin-bottom: 69px;
            .el-table .el-table__cell {
                pointer-events: none;
                padding: 30px 0;
            }

            .el-table th.el-table__cell.is-leaf,
            .el-table td.el-table__cell {
                border-bottom: 3px solid #e4e7ed;
            }
        }
    }
    .visualizar-relatorio-dados-rodape {
        position: relative;

        &::before {
            content: '';
            width: 100%;
            border-bottom: 2.3px solid var(--primary-lyra);
            color: var(--primary-lyra);
            position: absolute;
            left: 0;
            top: 0;
        }
        .visualizar-relatorio-dados-rodape-conteudo {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 20px;
            padding-top: 20px;

            .visualizar-relatorio-dados-rodape-conteudo-data {
            }

            .visualizar-relatorio-dados-rodape-conteudo-link {
                font-weight: bold;
                color: #359138;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
